import script from "./Users.vue?vue&type=script&setup=true&lang=ts"
export * from "./Users.vue?vue&type=script&setup=true&lang=ts"

import "./Users.vue?vue&type=style&index=0&id=0bac22a9&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bac22a9"]])

export default __exports__